import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'HOME', path: '/' },
    { name: 'MY STORY', path: '/about' },
    { name: 'SUPPORT', path: '/services' },
    { name: 'YOUR QUESTIONS', path: '/faqs' },
    { name: 'LETS CONNECT', path: '/contact' }
  ];

  return (
    <header className="w-full py-8" style={{ backgroundColor: '#f5f4f0' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Crystal Logo - Pulled even closer to top of page */}
        <div className="text-center mb-[10px] -mt-[40px]">
          <Link to="/">
            <img 
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/58a97dl1_logo%20transp.webp" 
              alt="Soul Bridge Logo" 
              className="w-[400px] h-auto mx-auto transition-opacity duration-300 hover:opacity-80"
            />
          </Link>
        </div>

        {/* Logo Text - Tight spacing on all devices */}
        <div className="text-center mb-[80px] -mt-[120px]">
          <Link to="/" className="text-[36px] tracking-[0.2em] inline-block transition-opacity duration-300 hover:opacity-80" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#c9b5a0' }}>
            SOUL BRIDGE DOULA
          </Link>
        </div>

        {/* Desktop Navigation - Much wider spread */}
        <nav className="hidden md:flex justify-center items-center space-x-[11.7rem]">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`text-sm tracking-widest whitespace-nowrap transition-colors duration-300 ${
                location.pathname === item.path 
                  ? 'text-[#815863] font-semibold' 
                  : 'text-gray-700 hover:text-[#815863]'
              }`}
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex justify-center">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-700 hover:text-[#815863] transition-colors"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 flex flex-col items-center space-y-4 py-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-widest transition-colors ${
                  location.pathname === item.path 
                    ? 'text-[#815863] font-semibold' 
                    : 'text-gray-700 hover:text-[#815863]'
                }`}
                style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
